import React, { useMemo } from 'react';

import SiteSettingsContext from './siteSettings.context';
import siteSettingsInitialState from './siteSettings.state';

/**
 * @type {React.FC}
 */

function SiteSettingsProvider({
  children,
  value,
}) {
  const context = useMemo(() => ({
    ...siteSettingsInitialState,
    data: value ?? siteSettingsInitialState.data,
  }), [value]);

  return (
    <SiteSettingsContext.Provider value={context}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export default SiteSettingsProvider;